module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Empresa " + _vm._s(this.company.name))])]), _vm._v(" "), _c('CompanyForm', {
    attrs: {
      "company": _vm.company,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6043bbdd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/companies/EditCompany.vue
// module id = 680
// module chunks = 1